import { HelmetDexteel } from "@dexteel/mesf-core";
import { TableGasAllocations } from "./components/TableGasAllocations";

export const GasAllocationsPage = () => (
	<>
		<HelmetDexteel title="Gas Allocations" />
		<TableGasAllocations />
	</>
);
